import { fonts } from 'consumer-components';
import { FormProps, reduxForm } from 'redux-form';
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import autobind from 'autobind-decorator';

import * as formUtils from 'login-utils/formUtils';
import FormBody from '../FormComponents/FormBody';
import InputMap from 'login-components/Common/Inputs/InputMap';
import PaneLayoutConstants from 'login-constants/paneLayoutConstants';
import PrimaryButton from 'login-components/Common/Buttons/PrimaryButton';
import { paneFormStyles } from 'login-components/Common/PaneLayout/paneStyles';

const styles = StyleSheet.create({
  container: {
    ...PaneLayoutConstants.splitContentStaticWidthMixin,
    ...fonts.Roboto,
    position: 'relative',
    top: 0,
  },
});

const inputs: FormInput[] = [
  {
    ...InputMap.EmailInput,
    name: 'username',
    identifier: 'username',
    label: 'Email',
    hidePlaceholder: true,
  },
  {
    ...InputMap.PasswordInput,
    name: 'password',
    identifier: 'password',
    label: 'Password',
    hidePlaceholder: true,
  },
];

const FORM_ERROR_ID = 'LoginForm-formError';

export interface LoginFormProps extends FormProps<any, any, any> {
  successMsg?: string | false | null;
  errorMsg?: string;
}

@autobind
export class LoginForm extends React.Component<LoginFormProps, {}> {
  private loginFormRef = React.createRef<HTMLFormElement>();

  submitLogin() {
    formUtils.submitForm(this.loginFormRef.current!);
  }

  render() {
    const { handleSubmit, errorMsg, successMsg, submitting } = this.props;
    return (
      <form
        ref={this.loginFormRef}
        action="/api/public/login"
        method="POST"
        className={css(styles.container)}
        id="it-LoginForm"
        noValidate
        onSubmit={handleSubmit!(this.submitLogin)}
      >
        <FormBody
          inputs={inputs}
          errorId={FORM_ERROR_ID}
          errorMsg={errorMsg}
          successMsg={successMsg}
          showForgotPassword={true}
        />
        <div className={css(paneFormStyles.buttonDisplay, paneFormStyles.buttonPadding)}>
          <PrimaryButton isWide={true} buttonId="it-LoginSubmit" disabled={submitting} text="Sign in" />
        </div>
      </form>
    );
  }
}

const ConnectedLoginForm = reduxForm({
  form: 'login',
  validate: values => formUtils.validate(inputs, values),
  onSubmitFail: syncErrors => formUtils.focusOnSubmitFail(syncErrors, FORM_ERROR_ID),
})(LoginForm);

export default ConnectedLoginForm;
